const checkIfArray = (input) => {
  if (input === undefined) return
  else return Array.isArray(input) ? input : [...[input]]
}

export default checkIfArray
